import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "repatriated-freelancer-onboarding__wrapper" }
const _hoisted_2 = { class: "repatriated-freelancer-onboarding__steps" }
const _hoisted_3 = { class: "repatriated-freelancer-onboarding__title" }
const _hoisted_4 = {
  key: 0,
  class: "repatriated-freelancer-onboarding__description"
}

import {useTranslation} from '@malt/vue3-use';
    import {VJoyDialog, VJoyText} from '@maltjoy/core-vue';
    import {ref} from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RepatriationOnboardingModal',
  props: {
        companyName: {type: String, required: false},
    },
  setup(__props) {

    

    const {msg, $requireMsg} = useTranslation();
    const dialogRef = ref<InstanceType<typeof VJoyDialog>>();

    function hideModal() {
        dialogRef.value?.hide();
    }

    $requireMsg('repatriation-opportunity.ob');

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createBlock(_unref(VJoyDialog), {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "repatriated-freelancer-onboarding",
    open: "",
    size: "large",
    "data-testid": "repatriated-freelancer-onboarding-modal"
  }, {
    "dialog-header": _withCtx(() => [
      _createVNode(_unref(VJoyText), { preset: "secondary-200" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msg)('repatriation-opportunity.ob.title', __props.companyName)), 1)
        ]),
        _: 1
      })
    ]),
    "dialog-subheader": _withCtx(() => [
      _createVNode(_unref(VJoyText), { preset: "primary-600" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msg)('repatriation-opportunity.ob.subtitle')), 1)
        ]),
        _: 1
      })
    ]),
    "dialog-body": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (step) => {
            return _createElementVNode("div", {
              key: `step-${step}`,
              class: _normalizeClass({'repatriated-freelancer-onboarding__step': true, active: step === 1})
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(`${step}. ${_unref(msg)(`repatriation-opportunity.ob.step.${step}.title`)}`), 1),
              (step === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(msg)(`repatriation-opportunity.ob.step.1.description`)), 1))
                : _createCommentVNode("", true)
            ], 2)
          }), 64))
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: `https://dam.malt.com/repatriation-opportunity/onboarding/onboarding-freelancer-step-1.svg`,
          alt: "freelancer onboarding visual"
        }, null, -1))
      ])
    ]),
    "dialog-confirm": _withCtx(() => [
      _createVNode(_component_VJoyButton, {
        variant: "main",
        class: "repatriated-freelancer-onboarding__cta",
        onClick: hideModal
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`${_unref(msg)(`repatriation-opportunity.ob.step.1.cta`)}`), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})